import { useState, useEffect } from 'react';
import AffiliateService from '../../services/affiliate';
import AffiliateTable from './AffiliateTable';
import { useNotification } from '../../contexts/NotificationContext';
import { useError } from '../../contexts/ErrorContext';

const Affiliates = () => {
    const [affiliates, setAffiliates] = useState(null);
    const { createNotification } = useNotification();
    const { showError } = useError();

    useEffect(() => {
        if (affiliates === null) {
            AffiliateService.getAll().then(data => {
                setAffiliates(data.affiliates)
            }).catch(showError);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [affiliates]);

    const handleProviderChange = (affiliate, newProvider) => {
        AffiliateService.setNachaProvider(affiliate.id, newProvider).then(response => {
            setAffiliates(prev => prev && prev.map(a => a.id === affiliate.id ? { ...a, nachaProvider: newProvider } : a));
            createNotification(`${affiliate.name} NACHA provider has been updated to ${newProvider}`);
        }).catch(showError);
    };

    return affiliates === null ? (
        <h1>Loading...</h1>
    ) : !affiliates.length ? (
        <h1>No Affiliates Found</h1>
    ) : (
        <div id="affiliates-container">
            <h1>Affiliates</h1>
            <AffiliateTable affiliates={affiliates} onProviderChange={handleProviderChange} />
        </div>
    );
}

export default Affiliates;
